import styled from "styled-components";
import colors from "@styling/colors";
import { borderRadius, spacing } from "@styling/sizing";
import { fontSizes } from "@styling/fonts";

const ChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${spacing.x1}px;
`;

const Chip = styled.button`
  font-size: ${fontSizes.small}px;
  padding: ${spacing.x1}px ${spacing.x2}px;
  border-radius: ${borderRadius.regular}px;
  border: 1px solid ${colors.primary};
  background-color: ${colors.background};
  color: ${colors.primary};
  cursor: pointer;
  text-align: left;
  &:hover:not(:disabled) {
    background-color: ${colors.primary};
    color: ${colors.primaryContrastText};
  }
  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
`;

type Props = {
  chips: { key: string; label: string; message: string }[];
  onSelect: (message: string) => void;
  disabled?: boolean;
};

export function ChatChips({ chips, onSelect, disabled }: Props) {
  return (
    <ChipRow>
      {chips.map((chip) => (
        <Chip
          key={chip.key}
          type="button"
          disabled={disabled}
          onClick={() => onSelect(chip.message)}
        >
          {chip.label}
        </Chip>
      ))}
    </ChipRow>
  );
}
